import React from 'react';
import { getAvatarVariantUrl } from '../../utils/avatarVariants';
import './SocialPresenceModal.css';

const activityIcon = { workout: '🏋️', meal: '🍽️', media: '📸', metric: '📊', survey: '📝' };

const SocialPresenceModal = ({ audience, initialPeople = [], initialLabel = 'Training circle', close, onUserClick, onActivityClick }) => {
  const groups = [
    ['Friends', audience?.friends || []],
    ['Dojo', audience?.dojo || []],
  ];
  const people = initialPeople.length ? initialPeople : groups.flatMap(([, values]) => values);
  const seen = new Set();

  return (
    <div className="social-presence-modal">
      <header className="social-presence-modal-header">
        <div><span className="social-presence-modal-kicker">Training circle</span><h2>{initialLabel}</h2></div>
        <button type="button" onClick={close} aria-label="Close">×</button>
      </header>
      <p className="social-presence-modal-note">Only activity visible to you is shown.</p>
      <div className="social-presence-modal-list">
        {people.map(person => {
          if (seen.has(person.userId)) return null;
          seen.add(person.userId);
          const user = { _id: person.userId, display_name: person.displayName, avatar_url: person.avatarUrl };
          return (
            <div className="social-presence-person" key={person.userId}>
              <button type="button" className="social-presence-person-main" onClick={() => onUserClick(user)}>
                <span className={`social-presence-modal-avatar ${person.state === 'ongoing' ? 'ongoing' : ''}`}>
                  {person.avatarUrl ? <img src={getAvatarVariantUrl(user, 'sm')} alt="" /> : (person.displayName || 'M')[0].toUpperCase()}
                </span>
                <span><strong>{person.displayName}</strong><small>{person.state === 'ongoing' ? 'Training now' : 'Completed recently'}</small></span>
              </button>
              {person.activity?.id && (
                <button type="button" className="social-presence-activity" onClick={() => onActivityClick({ _id: person.activity.id }, user)}>
                  {activityIcon[person.activity.type] || '🥋'} {person.activity.name}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SocialPresenceModal;